export const CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS
export const MINT_PRICE_ETH = '0.00001'
export const BASE_SIGNATURE = '0x'
